const SemVerGte = require('semver/functions/gte')

angular.module('surfsightApp.controllers').controller('EdgeEditController', [
  '$scope',
  '$rootScope',
  '$timeout',
  '$interval',
  '$http',
  '$localStorage',
  '$mdDialog',
  '$mdToast',
  'dataFromCaller',
  'edgeFactoryV2',
  '$mdSidenav',
  'nominatimLookUp',
  '$filter',
  function editEdgeController (
    $scope,
    $rootScope,
    $timeout,
    $interval,
    $http,
    $localStorage,
    $mdDialog,
    $mdToast,
    dataFromCaller,
    edgeFactoryV2,
    $mdSidenav,
    nominatimLookUp,
    $filter
  ) {
    const $translate = $filter('translate')
    $scope.edgeData = dataFromCaller.edge
    $scope.serialNumber = dataFromCaller.edge.imei // .uri
    $scope.data = {}
    $scope.data = dataFromCaller
    $scope.qrcodeCanvas = ''
    $scope.loading = true
    $scope.showUpdateButton = false
    $scope.old_device = false
    $scope.uiSettings = {}
    $scope.uiSettingsOnDevice = {}
    const userType = $localStorage.userDetails.type
    const partnerId =
      $localStorage.currentUserOrganization.reseller_id ||
      (userType === 'reseller' ||
      userType === 'sub-reseller' ||
      userType === 'reseller-contact'
        ? $localStorage.userDetails.id
        : null)
    // Check if recording encryption feature is enabled
    $scope.isRecordingEncryptionFeatureEnabled = false
    const featureFlagRequest = {
      method: 'POST',
      url: `${EDGE_BASEURL}/red-recording-encryption-feature`,
      data: {
        partnerId
      }
    }

    $http(featureFlagRequest)
      .then(featureFlagResponse => {
        $scope.isRecordingEncryptionFeatureEnabled =
          featureFlagResponse.data.enabled || false
      })
      .catch(featureFlagError => {
        console.error(
          'Failed to check encryption feature flag:',
          featureFlagError
        )
        $scope.isRecordingEncryptionFeatureEnabled = false
      })
    $scope.uiSettingsEditConfig = {
      cancelLabel: 'Back'
    }
    $scope.privacySettingsEditConfig = {
      cancelLabel: 'Cancel',
      backLabel: 'Back'
    }
    /*
      show demo mode switch to the user in following cases
      1. User has roleType of administrator
      2. Device is a Ai-12 Device.
    */
    const permissionRole =
      $localStorage &&
      $localStorage.userDetails &&
      $localStorage.userDetails.permission_role
        ? $localStorage.userDetails.permission_role
        : ''
    const isSuperAdmin =
      $localStorage &&
      $localStorage.userDetails &&
      $localStorage.userDetails.super_admin === true
    $scope.demoMode = {
      show: false, // Temporarily disabling demo mode for AI-12 due to a device-side bug
      value: false
    }
    const promises = [
      edgeFactoryV2.getSingleDevice(
        $rootScope.currentUserOrganization.id,
        $scope.serialNumber
      )
    ]
    // Only fetch the demoMode status when necessary
    if ($scope.demoMode.show) {
      promises.push(edgeFactoryV2.getDemoMode($scope.serialNumber))
    }
    Promise.all(promises)
      .then(async responses => {
        const { cameras, location, ...device } = responses[0]
        let demoModeResponse
        // hide embedded cameras, which are returned by API V2, but it's not presented on UI
        device.cameras = cameras.filter(({ cameraId }) => cameraId > 2)
        $scope.edgeData = { cameras, location, ...device }
        $scope.location_search.text = angular.copy(location)
        $scope.firmwareVersion = device.firmwareVersion
        if (window.isAI14Device($scope.serialNumber)) {
          if (device.firmwareVersion) {
            $scope.demoMode.show =
              SemVerGte(device.firmwareVersion, '14.4.1') &&
              $localStorage.userDetails.is_reseller === false &&
              !['reseller', 'sub-reseller', 'reseller-contact'].includes(
                $localStorage.userDetails.type
              ) &&
              (permissionRole === 'administrator' || isSuperAdmin)
          }
          if ($scope.demoMode.show) {
            demoModeResponse = await edgeFactoryV2.getDemoMode(
              $scope.serialNumber
            )
          }
        } else {
          demoModeResponse = responses[1]
        }

        if ($scope.demoMode.show) {
          const { demoMode } = demoModeResponse.data
          $scope.demoMode.value = demoMode
        }
      })
      .catch(error => {
        $scope.loading = false
        const errorMessage =
          (error.data && error.data.message) ||
          (error.data && error.data.status && error.data.status.error) ||
          'internal server error'
        $scope.showMessageToast(errorMessage)
        handleServerError(error)
      })

    /** TODO: migrate OTA Version - waiting for backend to add API v2 enpoint equivalent */
    $scope.updateOTAVersion = function () {
      const URI = $scope.URI
      // var request_data = {"message_type":"upgrade", "url":URI}
      const requestData = {
        message_type: 'upgrade',
        data: {
          url: URI
        }
      }
      const requestJson = {
        method: 'POST',
        url:
          DEVICEMANAGER_BASEURL +
          '/device/' +
          $scope.serialNumber +
          '/messages',
        data: requestData
      }
      $http(requestJson).then(result => {
        if (result.data.status.code === 0) {
          $scope.showMessageToast('Update has been sent to the dashcam')
          $mdDialog.cancel()
        }
      })
    }
    $scope.getCameraNameByStreamId = (edge, streamId) =>
      window.getCameraNameByStreamId($filter('translate'), edge, streamId)
    $scope.getDeviceTelemetry = () => {
      $scope.loading = true

      edgeFactoryV2
        .getDeviceTelemetry($scope.serialNumber)
        .then(data => {
          $scope.isOnline = true // device is online if response was 200 - no error
          $scope.setDeviceDetails(data)
        })
        .catch(response => {
          if (response.status === 417 || response.status === 404) {
            // device is offline - load only system details
            $scope.isOnline = false
            const { item } = edgeFactoryV2.findItemByImei($scope.serialNumber)
            $scope.setDeviceDetails(item)
          } else {
            $scope.isUnvailable = true
            handleServerError(response)
            $scope.showMessageToast(response.data.message)
          }
        })
        .finally(() => {
          $scope.loading = false
        })
    }

    $scope.getDeviceTelemetry()
    $scope.location_search = {
      text: ''
    }

    $scope.searchLocations = function (query) {
      return nominatimLookUp.querySearch(query)
    }

    $scope.placeChanged = function (place) {
      if (place) {
        $scope.edgeData.latitude = parseFloat(place.lat)
        $scope.edgeData.longitude = parseFloat(place.lon)
      }
    }

    $scope.editEdge = function () {
      var name = $scope.edgeData.name
      if (name) {
        $scope.edgeData.uri_type = parseInt($scope.edgeData.uri_type)
        $scope.edgeData.edge_type = parseInt($scope.edgeData.edge_type)
        const inputObject = (({
          uri,
          uri_type,
          organizationId,
          edge_type,
          name,
          location,
          latitude,
          longitude
        }) => ({
          uri,
          uri_type,
          organizationId,
          edge_type,
          name,
          location,
          latitude,
          longitude
        }))($scope.edgeData)

        edgeFactoryV2
          .updateDevice($scope.serialNumber, name)
          .then(function (response) {
            $mdDialog.hide(response)
          })
          .catch(error => {
            const toast = $mdToast
              .simple()
              .textContent(error.data.message)
              .action('ok')
              .position('bottom')
              .actionKey('F1')
              .hideDelay(5000)
              .parent('#edit-edge-container')

            $mdToast.show(toast)
          })
      }
    }

    /** TODO: migrate update-device-cameras - waiting for backend to add API v2 enpoint equivalent */
    $scope.editAuxiliaryCameras = () => {
      // todo: temporary solution to get ID of device based on IMEI for v1 request, which requires ID
      edgeFactoryV2.getEdgeIdByImei($scope.serialNumber).then(id => {
        $http({
          method: 'POST',
          url: `${EDGE_BASEURL}/edge/${id}/update-device-cameras`,
          data: $scope.cameras
        })
          .then(function ({
            data: {
              status: { code, error }
            }
          }) {
            if (code === 0) {
              const { item } = edgeFactoryV2.findItemByImei($scope.serialNumber)
              item.cameras = $scope.cameras
              edgeFactoryV2.addOrUpdateItem(item)
              $scope.edgeData.cameras = $scope.cameras
              $scope.showEdit()
            } else {
              const toast = $mdToast
                .simple()
                .textContent(error)
                .action('ok')
                .position('bottom')
                .actionKey('F1')
                .hideDelay(5000)
                .parent('#edit-edge-container')
              $mdToast
                .show(toast)
                .then(() => {})
                .catch(() => {})
            }
          })
          .catch(error => handleServerError(error))
      })
    }
    $scope.selected_tab = 0
    $scope.scanner_type = 'barcode'
    $scope.qr_code_scanner = {
      start_scanning: function () {
        $scope.qr_code_scanner.cameraRequested = true
        $scope.qr_code_scanner.cameraIsOn = true
        $scope.scanning_in_prgress = true
      },
      stop_scanning: function () {
        $scope.qr_code_scanner.cameraRequested = false
        $scope.qr_code_scanner.cameraIsOn = false
        $scope.scanning_in_prgress = false
      },
      toggle_scanning: function () {
        if ($scope.qr_code_scanner.cameraIsOn) {
          $scope.qr_code_scanner.stop_scanning()
        } else {
          $scope.qr_code_scanner.start_scanning()
        }
      },
      processURLfromQR: function (url) {
        $scope.qr_code_scanner.url = url
        $scope.qr_code_scanner.toggle_scanning()
        $scope.scanned_serial_number = url
      },
      onError: function (error = null) {
        // ~ console.log('error in sanning');
      },
      cameraRequested: false,
      cameraIsOn: false
    }
    $scope.show_scanner = function () {
      $scope.selected_tab = 1
      $scope.scanner_type = undefined
      $scope.select_scanner('barcode') // currently QR code scanning is not included in the application
    }
    $scope.hide_scanner = function () {
      if ($scope.scanner_type == 'qr') {
        $scope.qr_code_scanner.stop_scanning()
      }
      if ($scope.scanner_type == 'barcode') {
        $scope.bar_code_scanner.stop_scanning()
      }
      $timeout(function () {
        $scope.selected_tab = 0
      }, 300)
    }
    $scope.enter_scanner_fullscreen = function () {
      if ($scope.scanner_type == 'qr') {
        $scope.qr_code_scanner.fullScreen = true
      }
      if ($scope.scanner_type == 'barcode') {
        $scope.bar_code_scanner.fullScreen = true
      }
    }
    $scope.scan_completed = function () {
      $scope.edgeData.uri = angular.copy($scope.scanned_serial_number)
      $scope.hide_scanner()
    }
    $scope.select_scanner = function (type = 'barcode') {
      if (type == 'barcode') {
        if ($scope.scanner_type == 'qr') {
          $scope.qr_code_scanner.stop_scanning()
        }
        $scope.scanner_type = type
        $scope.selectedCamera = $scope.getBackcamera()
        $timeout(function () {
          $scope.bar_code_scanner.start_scanning()
        }, 200)
      } else if (type == 'qr') {
        if ($scope.scanner_type == 'barcode') {
          $scope.bar_code_scanner.stop_scanning()
        }
        $scope.scanner_type = type
        $timeout(function () {
          $scope.qr_code_scanner.start_scanning()
        }, 200)
      }
    }
    $scope.backCameraFound = false
    $scope.getBackcamera = function () {
      var returnValue = undefined
      $scope.availableCameras.forEach(function (c) {
        if (c.name.indexOf('back') > 0) {
          returnValue = c.deviceId
        }
      })
      return returnValue
    }
    $scope.bar_code_scanner = {
      start_scanning: function () {
        $scope.scanning_in_prgress = true
        $scope.bar_code_scanner.cameraIsOn = true
      },
      stop_scanning: function () {
        $scope.bar_code_scanner.cameraIsOn = false
        $scope.scanning_in_prgress = false
      },
      toggle_scanning: function () {
        if ($scope.bar_code_scanner.cameraIsOn) {
          $scope.bar_code_scanner.stop_scanning()
        } else {
          $scope.bar_code_scanner.start_scanning()
        }
      },
      onProcessed: function (result) {},
      onDetected: function (result) {
        $scope.bar_code_scanner.fullScreen = false
        $scope.bar_code_scanner.stop_scanning()
        $scope.scanned_serial_number = result.codeResult.code
      },
      cameraIsOn: false,
      cameraId: undefined,
      fullScreen: false,
      fullScreenTracker: function (isFullScreen) {
        this.fullScreen = isFullScreen
      }
    }
    $scope.scanned_serial_number = undefined
    $scope.scanning_in_prgress = false
    $scope.show_barcode_scanner = function () {
      $scope.selected_tab = 1
      $scope.qr_code_scanner.start_scanning()
    }
    $scope.hide_barcode_scanner = function () {
      $scope.selected_tab = 0
      $scope.qr_code_scanner.stop_scanning()
    }
    $scope.barcode_scan_completed = function () {
      $scope.newedge.uri = angular.copy($scope.scanned_serial_number)
      $scope.hide_scanner()
    }
    $scope.toggle_scanner_camera = function () {
      if ($scope.scanner_type == 'qr') {
        $scope.qr_code_scanner.toggle_scanning()
      }
      if ($scope.scanner_type == 'barcode') {
        $scope.bar_code_scanner.toggle_scanning()
      }
    }
    $scope.availableCameras = []
    $scope.loadCameras = function () {
      function gotDevices (deviceInfos) {
        var tempCameras = []
        for (var i = 0; i !== deviceInfos.length; ++i) {
          var deviceInfo = deviceInfos[i]
          if (deviceInfo.kind === 'videoinput') {
            tempCameras.push({
              deviceId: deviceInfo.deviceId,
              name:
                deviceInfo.label || 'camera ' + (availableCameras.length + 1)
            })
          }
        }
        $scope.availableCameras = tempCameras
      }

      function errorCallback (err) {
        // ~ console.log('got error');
      }

      navigator.mediaDevices
        .enumerateDevices()
        .then(gotDevices)
        .catch(errorCallback)
      $timeout(function () {
        $scope.loadCameras()
      }, 1000)
    }
    $scope.loadCameras()
    $scope.cancel = function () {
      $mdDialog.cancel()
    }
    $scope.showEdit = () => {
      $scope.selected_tab = 0
    }
    $scope.showWifiQRcode = function () {
      $scope.selected_tab = 2
    }
    $scope.showReplaceDeviceForm = function () {
      $scope.selected_tab = 5
    }
    $scope.showDataUsageForm = function () {
      $scope.dataUsage()
      $scope.selected_tab = 6
    }
    $scope.showAuxiliaryCameras = () => {
      $scope.cameras = angular.copy($scope.edgeData.cameras)
      $scope.selected_tab = 4
    }
    $scope.showUiSettingsForm = function () {
      $scope.selected_tab = 7
    }
    $scope.showPrivacyModeForm = function () {
      getPrivacyModeConfig()
      $scope.selected_tab = 8
    }
    $scope.wakeUpDevice = function () {
      const serialNumber = $scope.serialNumber
      const requestJson = {
        method: 'POST',
        url: `${V2_BASEURL}/devices/${serialNumber}/wakeup`,
        data: {}
      }
      $http(requestJson)
        .then(result => {
          if (result.status === 200) {
            $mdDialog.cancel()
          }
        })
        .catch(error => {
          if (error.status == 404) {
            const message = error.data.message
            const regex = /offline/
            // Show error only when device is offline
            if (regex.test(message))
              $scope.showMessageToast($translate('offlineDeviceError'))
          } else {
            $scope.showMessageToast($translate('failedToWakeUpError'))
          }
          $mdDialog.cancel()
        })
    }
    $scope.partialWakeUpDevice = function () {
      const serialNumber = $scope.serialNumber
      const requestJson = {
        method: 'PUT',
        url: `${V2_BASEURL}/devices/${serialNumber}/semi-online`,
        data: {}
      }
      $http(requestJson)
        .then(result => {
          if (result.status === 200) {
            $mdDialog.cancel()
          }
        })
        .catch(error => {
          console.log(error)
          $scope.showMessageToast($translate('partialWakeUpError'))
          $mdDialog.cancel()
        })
    }

    $scope.openEncryptionKeys = function () {
      const serialNumber = $scope.serialNumber
      const edgeEditData = $scope.data

      showReAuthDialog()

      function showReAuthDialog () {
        $mdDialog
          .show({
            template: `
            <md-dialog aria-label="Re-authenticate" style="min-width: 600px; max-width: 800px;">
              <md-toolbar>
                <div class="md-toolbar-tools">
                  <h2>Re-authenticate</h2>
                  <span flex></span>
                  <md-button class="md-icon-button" ng-click="cancel()">
                    <ng-md-icon icon="close" style="fill:white;"></ng-md-icon>
                  </md-button>
                </div>
              </md-toolbar>
              <md-dialog-content style="padding: 20px;">
                <div class="md-dialog-content">
                  <form autocomplete="off" novalidate ng-submit="submit()">
                    <!-- Hidden username sink to absorb password-manager autofill so it does not
                         leak into inputs on the underlying page (e.g. the Devices search box). -->
                    <input type="text" name="username" autocomplete="username"
                      style="position:absolute; left:-10000px; width:1px; height:1px; opacity:0;"
                      tabindex="-1" aria-hidden="true">
                    <md-input-container class="md-block">
                      <label>Password</label>
                      <input type="password" name="reauth-password" autocomplete="new-password"
                        ng-model="password" ng-keypress="handleKeyPress($event)" ng-disabled="isLoading">
                    </md-input-container>
                    <div ng-if="errorMessage" class="md-warn" style="color: red; margin-top: 10px;">
                      {{errorMessage}}
                    </div>
                  </form>
                </div>
              </md-dialog-content>
              <md-dialog-actions layout="row">
                <md-button ng-click="cancel()" ng-disabled="isLoading">
                  Cancel
                </md-button>
                <md-button class="md-primary md-raised" ng-click="submit()" ng-disabled="!password || isLoading">
                  <span ng-if="!isLoading">Submit</span>
                  <span ng-if="isLoading">Authenticating...</span>
                </md-button>
              </md-dialog-actions>
            </md-dialog>
          `,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            locals: {
              edgeEditData: edgeEditData
            },
            controller: [
              '$scope',
              '$mdDialog',
              '$http',
              'edgeEditData',
              function ($scope, $mdDialog, $http, edgeEditData) {
                $scope.password = ''
                $scope.errorMessage = ''
                $scope.isLoading = false

                $scope.handleKeyPress = function ($event) {
                  if (
                    $event.keyCode === 13 &&
                    $scope.password &&
                    !$scope.isLoading
                  ) {
                    $scope.submit()
                  }
                }

                $scope.cancel = function () {
                  $mdDialog.cancel(edgeEditData)
                }

                $scope.submit = function () {
                  if (!$scope.password || $scope.isLoading) {
                    return
                  }
                  $scope.errorMessage = ''
                  $scope.isLoading = true

                  const reAuthRequest = {
                    method: 'POST',
                    url: `${USER_BASEURL}/re-authenticate`,
                    data: { password: $scope.password },
                    headers: {
                      'Skip-Auth-Logout': true
                    }
                  }

                  $http(reAuthRequest)
                    .then(response => {
                      if (response.status === 200) {
                        $mdDialog.hide($scope.password)
                      }
                    })
                    .catch(error => {
                      $scope.isLoading = false
                      $scope.errorMessage =
                        (error.data && error.data.message) ||
                        (error.data &&
                          error.data.status &&
                          error.data.status.error) ||
                        'Authentication failed'
                      $scope.password = ''
                    })
                }
              }
            ]
          })
          .then(() => {
            fetchEncryptionKeys()
          })
          .catch(edgeEditData => {
            if (edgeEditData) {
              $mdDialog.cancel() // Close current re-authenticate edit modal
              $timeout(() => {
                $mdDialog.show({
                  locals: {
                    dataFromCaller: edgeEditData
                  },
                  controller: 'EdgeEditController',
                  templateUrl:
                    './templates/edge.edit.view.html?t=' + window.webpackHash,
                  parent: angular.element(document.body),
                  clickOutsideToClose: true,
                  fullscreen: true
                })
              }, 100)
            }
          })
      }

      function fetchEncryptionKeys () {
        const requestJson = {
          method: 'GET',
          url: `${V2_BASEURL}/devices/${serialNumber}/recording-encryption-keys`
        }

        $http(requestJson)
          .then(result => {
            const securityData = result.data
            showSecurityDialog(securityData)
          })
          .catch(error => {
            const errorMessage =
              (error.data && error.data.message) ||
              (error.data && error.data.status && error.data.status.error) ||
              'Failed to retrieve recording encryption keys'
            $scope.showMessageToast(errorMessage)
          })
      }

      function showSecurityDialog (securityData) {
        $mdDialog.show({
          templateUrl: './templates/security.view.html?t=' + window.webpackHash,
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          fullscreen: false,
          controller: [
            '$scope',
            '$mdDialog',
            '$localStorage',
            function ($scope, $mdDialog, $localStorage) {
              $scope.active = securityData.active
              $scope.keyHistory = securityData.keyHistory

              $scope.getFormattedDate = function (date) {
                if (!date) return ''
                if ($localStorage.timeFormat === 2) {
                  return moment(date).format('h:mm:ss A MMM DD YYYY')
                } else {
                  return moment(date).format('HH:mm:ss MMM DD YYYY')
                }
              }

              $scope.cancel = function () {
                $mdDialog.cancel()
              }
            }
          ]
        })
      }
    }
    var attributeRemover = $interval(function () {
      if (document.getElementById('search-location')) {
        document
          .getElementById('search-location')
          .removeAttribute('placeholder')
      }
    }, 100)
    $scope.$on('$destroy', function () {
      $interval.cancel(attributeRemover)
    })

    function handleServerError (response) {
      $scope.$emit('handleServerError', response)
    }

    $scope.confirmEdgeDelete = function (ev, edge_id) {
      $mdDialog.hide({
        type: 'delete'
      })
    }

    $scope.$watch('qrcodeCanvas', function () {
      if ($scope.qrcodeCanvas) {
        $scope.selected_tab = 3
        document.getElementById('qrcode').append($scope.qrcodeCanvas)
      }
    })
    $scope.showEdgeDashcam = function () {
      $scope.selected_tab = 2
    }
    $scope.$on('showEdgeDashcam', function () {
      $scope.selected_tab = 0
    })
    $scope.rmaData = {
      newSerialNumber: ''
    }
    $scope.confirmReplaceDevice = (ev, deviceId) => {
      if (confirm($translate('confirmReplaceDevice'))) {
        $scope.loading = true
        const rmaSerialNumber = $scope.serialNumber
        const newSerialNumber = $scope.rmaData.newSerialNumber
        const requestJson = {
          method: 'GET',
          url:
            EDGE_BASEURL +
            '/rpc-rma-replace-device/' +
            rmaSerialNumber +
            '/' +
            newSerialNumber
        }
        $http(requestJson)
          .then(result => {
            if (result.statusCode === 200) {
              $mdDialog.hide({
                type: 'rma',
                message: 'Device was replaced successfully'
              })
            } else {
              $mdDialog.hide({
                type: 'rma',
                message: result.data.status.error
              })
            }
          })
          .catch(ex => {
            $scope.showMessageToast(ex)
          })
          .finally(() => {
            $scope.loading = false
          })
      }
    }

    function getFormattedDate (date) {
      const year = date.getFullYear()
      const month = (1 + date.getMonth()).toString().padStart(2, '0')
      const day = date
        .getDate()
        .toString()
        .padStart(2, '0')
      if ($localStorage.measurementUnits === 1) {
        return `${day}/${month}/${year}`
      } else return `${day}/${month}/${year}`
    }

    $scope.dataUsageFields = {
      mobileData: 0,
      liveVideo: 0,
      videoEvents: 0,
      recordingsUploaded: 0,
      recordStreaming: 0,
      otherData: 0,
      billingDayOfMonth: 1,
      billingDate: getFormattedDate(new Date(Date.now()))
    }
    $scope.dataUsage = () => {
      $scope.loading = true
      const request_json = {
        method: 'GET',
        url:
          DEVICEMANAGER_BASEURL +
          '/device/' +
          $scope.serialNumber +
          '/data-usage',
        data: {}
      }
      $scope.printDataUsage = (value, decimals) => {
        if (value <= 0 || !value) {
          value = 0
        }
        const gbValue = value / (1024.0 * 1024.0 * 1024.0)
        const mbValue = value / (1024.0 * 1024.0)
        const kbValue = value / 1024.0

        if (Math.floor(gbValue) > 0) {
          return gbValue.toFixed(decimals).toString() + ' GB'
        }
        if (Math.floor(mbValue) > 0) {
          return mbValue.toFixed(decimals).toString() + ' MB'
        }
        if (Math.floor(kbValue) > 0.0) {
          return kbValue.toFixed(decimals).toString() + ' KB'
        }
        return value.toString() + ' B'
      }
      $scope.timeConvertion = millis => {
        if (!millis) {
          return ''
        }
        const hours = Math.floor(Math.floor(millis / 60000) / 60)
        const minutes = Math.floor(millis / 60000) % 60
        const seconds = minutes < 1 && ((millis % 60000) / 1000).toFixed(0)
        if (hours > 0) {
          if (minutes > 0) {
            return hours + ' Hours ' + minutes + ' Minutes'
          } else if (seconds) {
            return hours + ' Hours ' + seconds + ' Seconds'
          }
        } else if (minutes > 0) {
          if (seconds) {
            return minutes + ' Minutes' + seconds + ' Seconds'
          } else {
            return minutes + ' Minutes'
          }
          return minutes + ' Minutes'
        } else {
          return seconds + ' Seconds'
        }
      }
      $http(request_json)
        .then(result => {
          if (result.data.status.code === 0) {
            const decimal = 2
            $scope.dataUsageFields.billingDayOfMonth =
              result.data.dataUsage.billingDayOfMonth || 1
            const calDate = new Date(Date.now())
            while (
              calDate.getDate() !== $scope.dataUsageFields.billingDayOfMonth
            ) {
              calDate.setDate(calDate.getDate() - 1)
            }
            $scope.dataUsageFields.billingDate = getFormattedDate(calDate)
            $scope.dataUsageFields.mobileData = $scope.printDataUsage(
              result.data.dataUsage.mobile_tx + result.data.dataUsage.mobile_rx,
              decimal
            )
            $scope.dataUsageFields.liveVideo = $scope.printDataUsage(
              result.data.dataUsage.live_streaming_usage,
              decimal
            )
            $scope.dataUsageFields.liveVideoTime = $scope.timeConvertion(
              result.data.dataUsage.live_stream_usage_milli
            )
            $scope.dataUsageFields.videoEvents = $scope.printDataUsage(
              result.data.dataUsage.events_usage,
              2
            )
            $scope.dataUsageFields.recordingsUploaded = $scope.printDataUsage(
              result.data.dataUsage.recordings_upload_usage,
              decimal
            )
            $scope.dataUsageFields.recordStreaming = $scope.printDataUsage(
              result.data.dataUsage.record_streaming_usage,
              decimal
            )
            $scope.dataUsageFields.recordStreamingTime = $scope.timeConvertion(
              result.data.dataUsage.record_stream_usage_milli
            )
            $scope.dataUsageFields.videoEventsToday =
              (result.data.dataUsage.usage_events_today_day > 0 &&
                result.data.dataUsage.usage_events_today_day + ' Today,') ||
              ''
            $scope.dataUsageFields.videoEventsMonth =
              (result.data.dataUsage.usage_events_today_month > 0 &&
                result.data.dataUsage.usage_events_today_month + ' Month') ||
              ''
          } else {
            $scope.showMessageToast(result.data.status.error)
          }
        })
        .catch(ex => {
          $scope.showMessageToast(ex)
        })
        .finally(() => {
          $scope.loading = false
        })
    }

    const getUiSettings = () =>
      edgeFactoryV2
        .getDeviceSettings($scope.serialNumber)
        .then(({ data: { data } }) => {
          $scope.uiSettings = data
          $scope.uiSettingsOnDevice = angular.copy($scope.uiSettings)
        })
        .catch(({ data: { message } }) => {
          $scope.showMessageToast(message)
        })
    const getPrivacyModeConfig = () => {
      edgeFactoryV2
        .getDevicePrivacyModeConfig($scope.serialNumber)
        .then(({ data }) => {
          $scope.prevPrivacySettings = angular.copy(data.privacySettings)
          $scope.privacySettings = data.privacySettings
          $scope.privacyMode = data.privacyMode
          $scope.prevPrivacyMode = data.privacyMode
        })
        .catch(ex => {
          $scope.showMessageToast(ex)
        })
    }
    $scope.confirmUpdateUiSettings = () => {
      if (
        JSON.stringify($scope.uiSettings) ===
        JSON.stringify($scope.uiSettingsOnDevice)
      ) {
        // nothing changed
        $mdDialog.hide({
          type: 'settings_unchanged'
        })
      } else {
        $mdDialog.hide({
          type: 'settings_changed',
          edge: $scope.edgeData,
          data: $scope.uiSettings
        })
      }
    }

    $scope.confirmPrivacyModeUpdate = () => {
      const privacySettingsChanged =
        JSON.stringify($scope.privacySettings) !==
        JSON.stringify($scope.prevPrivacySettings)
      const privacyModeChanged = $scope.prevPrivacyMode !== $scope.privacyMode

      // updated privacy settings
      $mdDialog.hide({
        type: 'privacy_settings_changed',
        imei: $scope.serialNumber,
        privacyMode: privacyModeChanged ? $scope.privacyMode : null,
        privacySettings: privacySettingsChanged ? $scope.privacySettings : null
      })
    }

    $scope.showMessageToast = function (message = '') {
      var toast = $mdToast
        .simple()
        // remove exception name from error returned by some v2 API endpoint
        .textContent(message.replace(/^.*: /, ''))
        .action('ok')
        .position('bottom middle')
        .actionKey('F1')
        .hideDelay(3000)
        .parent('#broadcastview-add-container')

      $mdToast
        .show(toast)
        .then(function (response) {
          if (response == 'ok') {
            // alert('You clicked the \'UNDO\' action.');
          }
        })
        .catch(() => {})
    }

    $scope.getSdCardSpace = (sdCardSize, sdCardFreeSpace) => {
      const byteToGB = parseFloat(1024 * 1024 * 1024)
      return `${((parseFloat(sdCardSize) || 0) / byteToGB).toFixed(
        2
      )} GB Total / ${((parseFloat(sdCardFreeSpace) || 0) / byteToGB).toFixed(
        2
      )} GB Free Space`
    }

    $scope.setDeviceDetails = ({
      calibrationCompleted,
      deviceModel,
      firmwareVersion,
      lastSeenOnline,
      sdCardCapacityBytes,
      sdCardFreeBytes,
      sdCardInserted,
      simNetworkType,
      simOperator
    }) => {
      $scope.deviceModel = deviceModel
      if (firmwareVersion) {
        $scope.isFirmwareVersionValid = SemVerGte(firmwareVersion, '14.3.5')
      }
      if (lastSeenOnline) {
        $scope.turnedOnAt = moment(lastSeenOnline).format(
          $localStorage.timeFormat === 2
            ? 'MMM DD, YYYY hh:mm A Z'
            : 'MMM DD, YYYY HH:mm Z'
        )
      }
      /* TODO: migrate diagnostics - missing cellular_signal_level field */
      /* TODO: migrate diagnostics - how to use simState field from getDeviceTelemetry v2 endpoint */
      if ($scope.isOnline) {
        $scope.mobileStatus = `Connected to Network ${simOperator} ${simNetworkType}`
        $scope.calibrationState = calibrationCompleted ? 'Yes' : 'No'
        $scope.sdCardStatus = sdCardInserted
          ? $scope.getSdCardSpace(sdCardCapacityBytes, sdCardFreeBytes)
          : 'Not Inserted'
      }
      getUiSettings()
    }
    // Method to handle the demo mode switch
    $scope.confirmDemoModeSwitch = ev => {
      if ($scope.demoMode.value) {
        let failedOperation = false
        $mdDialog
          .show({
            templateUrl:
              '../../templates/demo-mode.confirmation-pop-up.view.html',
            targetEvent: ev,
            controller: [
              '$scope',
              '$mdDialog',
              'edgeFactoryV2',
              '$mdToast',
              'serialNumber',
              'demoMode',
              'demoModeActivationEvents',
              function (
                $scope,
                $mdDialog,
                edgeFactoryV2,
                $mdToast,
                serialNumber,
                demoMode,
                demoModeActivationEvents
              ) {
                $scope.demoModeActivationEvents = demoModeActivationEvents
                $scope.confirm = () => {
                  // if ai-14 device, use updateDemoModeV2
                  const isAI14Device =
                    $scope.deviceModel || window.isAI14Device(serialNumber)
                  edgeFactoryV2[
                    isAI14Device ? 'updateDemoModeV2' : 'updateDemoMode'
                  ](serialNumber, demoMode)
                    .catch(error => {
                      const toast = $mdToast
                        .simple()
                        .textContent(error.data.status.error)
                        .action('ok')
                        .position('bottom')
                        .actionKey('F1')
                        .hideDelay(5000)
                        .parent('#edit-edge-container')
                      $mdToast.show(toast)
                      failedOperation = true
                    })
                    .finally(() => {
                      $mdDialog.hide(!failedOperation)
                    })
                }
                $scope.cancel = function () {
                  $mdDialog.cancel()
                }
              }
            ],
            locals: {
              serialNumber: $scope.serialNumber,
              demoMode: $scope.demoMode.value,
              demoModeActivationEvents: [
                'distractedDriving',
                'smoking',
                'foodDrink',
                'cellPhoneUse',
                'driverUnbelted',
                'obstruction'
              ]
            }
          })
          .then(function (response) {
            $scope.demoMode.value = response
          })
      } else {
        edgeFactoryV2[isAI14Device ? 'updateDemoMode' : 'updateDemoModeV2'](
          $scope.serialNumber,
          $scope.demoMode.value
        )
          .then(function (response) {
            $mdDialog.hide(response)
          })
          .catch(error => {
            const toast = $mdToast
              .simple()
              .textContent(error.data.status.error)
              .action('ok')
              .position('bottom')
              .actionKey('F1')
              .hideDelay(5000)
              .parent('#edit-edge-container')

            $mdToast.show(toast)
            $scope.demoMode.value = true
          })
      }
    }
  }
])
